import { useEffect, useState } from 'react';
import { safeMessage } from '../utils/auditSafety';

export default function ValidationNotice() {
  const [message, setMessage] = useState('');
  useEffect(() => {
    const show = event => setMessage(safeMessage(event.detail, 'Please check your form entries.'));
    window.addEventListener('rcs-validation-error', show);
    return () => window.removeEventListener('rcs-validation-error', show);
  }, []);
  if (!message) return null;
  return <div role="alert" className="fixed top-4 left-1/2 -translate-x-1/2 z-[9999] w-[90%] max-w-xl rounded-lg border border-red-300 bg-red-50 p-4 text-red-800 shadow-lg flex items-start gap-4">
    <span className="flex-1">{message}</span>
    <button type="button" aria-label="Dismiss validation message" onClick={() => setMessage('')}>×</button>
  </div>;
}
